import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ScreenBackV2WithTitle } from '../../../Components/ScreenBackV2';
import OnboardingContainer from '../../Component/OnboardingContainer';
import {
  GetAllCityOfState,
  getLocationAndPincodeAction,
} from '../../auth/action';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditIcon from '@mui/icons-material/Edit';
import { GetAllStates } from '../../../../screen/auth/action/util_actions';
import useLocationPincode from '../../../CommonHooks/useLocationPincode';

const FirmOnboarding = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const fetchedData = location.state?.data || null;
  const edit_firm_details = location.state?.edit_firm_details || {};
  const isEditingFirm = Object.keys(edit_firm_details).length > 0;
  const [firmDetails, setFirmDetails] = useState({
    document_id: fetchedData?.document_id,
    firm_name: fetchedData?.company_name,
    firm_adddress: fetchedData?.street,
    firm_pincode: fetchedData?.pincode_id || '',
    state_name: fetchedData?.state_name,
    state_id: fetchedData?.state_id,
    district_name: fetchedData?.district_name,
    district_id: fetchedData?.district_id,
    document_type: fetchedData?.document_type,
    pancard_no: fetchedData?.pancard_no,
    gst_no: fetchedData?.gst_no,
    address_line_1: fetchedData?.address_line_1,
    address_line_2: fetchedData?.address_line_2,
    address_line_3: fetchedData?.address_line_3,
    location_id: fetchedData?.location_id || '',
    location_name: fetchedData?.location_name || '',
  });
  useEffect(() => {
    if (isEditingFirm) {
      setFirmDetails(edit_firm_details);
    }
  }, [isEditingFirm]);
  const [errors, setErrors] = useState({});
  const [districts, setDistricts] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allPincodes, setAllPincodes] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [firstSelection, setFirstSelection] = useState(null);

  const getStates = async () => {
    const { data, error, message } = await GetAllStates();
    if (!error) {
      setAllState(
        data.map((state) => ({ label: state.state_name, value: state.id })),
      );
    } else {
      toast.error(message);
    }
  };

  const getDistricts = async () => {
    const stateId = firmDetails?.state_id;

    const { data, error, message } = await GetAllCityOfState(stateId);

    if (!error) {
      setDistricts(
        data.map((district) => ({
          label: district.district_name,
          value: district.id,
        })),
      );
    } else {
      return toast.error(message);
    }
  };
  const getlocationPincode = async (
    districtId,
    locationId = null,
    PincodeId = null,
  ) => {
    if (PincodeId && firmDetails.location_id) return;
    if (locationId && firmDetails.firm_pincode) return;
    const { data, error } = await getLocationAndPincodeAction(districtId, {
      location_id: locationId,
      pincode_id: PincodeId,
    });
    if (!error) {
      if (locationId && !firmDetails.firm_pincode) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
      } else if (PincodeId && !firmDetails.location_id) {
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      } else if (!locationId && !PincodeId) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      }
    }
  };
  useEffect(() => {
    getStates();
  }, []);
  useEffect(() => {
    if (firmDetails?.state_id) getDistricts();
  }, [firmDetails?.state_id]);
  useEffect(() => {
    if (firmDetails?.district_id) getlocationPincode(firmDetails.district_id);
  }, [firmDetails.district_id]);

  const handleSubmit = () => {
    const errors = {};
    if (!firmDetails.document_id) errors.gst_no = 'GSTIN or PAN is required';
    if (!firmDetails.firm_name) errors.firm_name = 'Firm name is required';
    if (!firmDetails.address_line_1)
      errors.address_line_1 = 'Address Line 1 is required';
    if (!firmDetails.firm_pincode) errors.firm_pincode = 'Pincode is required';
    if (!firmDetails.state_id) errors.state = 'State is required';
    if (!firmDetails.district_id) errors.district = 'District is required';
    if (!firmDetails.location_id) errors.city = 'City is required';

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    if (isEditingFirm) {
      dispatch({
        type: 'ADD_FIRM',
        data: { ...edit_firm_details, ...firmDetails },
      });
      navigate('/FirmOnboardingSummary');
    } else {
      dispatch({
        type: 'SET_FIRM_GST_PAN_DETAILS',
        data: firmDetails,
      });

      navigate('/IndustrySelect');
    }
  };

  useEffect(() => {
    if (firmDetails.firm_pincode) {
      getlocationPincode(
        firmDetails.district_id,
        null,
        firmDetails.firm_pincode,
      );
    }
  }, [firmDetails.firm_pincode]);

  useEffect(() => {
    if (firmDetails.location_id) {
      getlocationPincode(
        firmDetails.district_id,
        firmDetails.location_id,
        null,
      );
    }
  }, [firmDetails.location_id]);
  useEffect(() => {
    if (firmDetails.firm_pincode && !firstSelection) {
      setFirstSelection('pincode');
      getlocationPincode(
        firmDetails.district_id,
        null,
        firmDetails.firm_pincode,
      );
    }
  }, [firmDetails.firm_pincode]);

  useEffect(() => {
    if (
      firmDetails.location_id &&
      firmDetails.location_name &&
      !firmDetails.firm_pincode &&
      !firstSelection
    ) {
      setFirstSelection('city');
    }
  }, [firmDetails.location_id]);

  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle title={'Firm Onboarding'} />
      <Box>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.gst_no}
        >
          <TextField
            className='darkBackground'
            fullWidth
            id='gst_no'
            type='text'
            value={firmDetails.gst_no}
            color='secondary'
            onChange={(e) => {}}
            label='Entered GSTIN'
            disabled={true}
            InputProps={{
              endAdornment: !isEditingFirm && (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='edit gst'
                    edge='end'
                    onClick={() => navigate('/FetchFirmDetail')}
                  >
                    <EditIcon sx={{ color: 'white' }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {errors.gst_no && <FormHelperText>{errors.gst_no}</FormHelperText>}
        </FormControl>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.pancard_no}
        >
          <TextField
            className='darkBackground'
            fullWidth
            disabled={true}
            id='pancard_no'
            type='text'
            value={firmDetails.pancard_no}
            color='secondary'
            onChange={(e) => {}}
            label='Entered PAN'
            InputProps={{
              endAdornment: !isEditingFirm && (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='edit gst'
                    edge='end'
                    onClick={() => navigate('/FetchFirmDetail')}
                  >
                    <EditIcon sx={{ color: 'white' }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {errors.pancard_no && (
            <FormHelperText>{errors.pancard_no}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.firm_name}
        >
          <TextField
            className='darkBackground'
            fullWidth
            id='firm_name'
            type='text'
            value={firmDetails.firm_name}
            color='secondary'
            onChange={(e) =>
              setFirmDetails({
                ...firmDetails,
                firm_name: e.target.value,
              })
            }
            label='Firm Name'
          />
          {errors.firm_name && (
            <FormHelperText>{errors.firm_name}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          sx={{ width: '38%', marginRight: '2%' }}
          margin='normal'
        >
          <InputLabel
            sx={{
              color: 'white',
              '&.Mui-focused': {
                color: 'white',
              },
              '&.Mui-disabled': {
                color: '#999999',
              },
            }}
            id='State'
            disabled={fetchedData?.gst_no}
          >
            State
          </InputLabel>
          <Select
            label='State'
            onChange={(e) => {
              const selectedValue = e.target.value;
              const selectedLabel = allState.find(
                (option) => option.value === selectedValue,
              ).label;
              setFirmDetails({
                ...firmDetails,
                state_id: selectedValue,
                state_name: selectedLabel,
              });
            }}
            value={firmDetails?.state_id || ''}
            sx={{
              color: 'white',
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '.MuiSvgIcon-root': {
                color: 'white',
              },
              '.MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled':
                {
                  opacity: 1,
                  color: '#999999',
                  '-webkit-text-fill-color': 'unset',
                },
              '&.Mui-disabled': {
                color: '#999999',
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: '#999999',
                },
                '.MuiSvgIcon-root': {
                  color: '#999999',
                },
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  bgcolor: 'white',
                  '& .MuiMenuItem-root': {
                    padding: '10px',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  },
                },
              },
            }}
            disabled={fetchedData?.gst_no}
          >
            {allState.map((state) => (
              <MenuItem
                key={state.value}
                value={state.value}
              >
                {state.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{ width: '40%' }}
          margin='normal'
        >
          <InputLabel
            sx={{
              color: 'white',
              '&.Mui-focused': {
                color: 'white',
              },
            }}
            id='district'
          >
            District
          </InputLabel>
          <Select
            label='district'
            onChange={(e) => {
              const selectedValue = e.target.value;
              const selectedLabel = districts.find(
                (option) => option.value === selectedValue,
              ).label;
              setFirmDetails({
                ...firmDetails,
                district_id: selectedValue,
                district_name: selectedLabel,
                location_id: '',
                location_name: '',
                firm_pincode: '',
              });
              setFirstSelection(null);
            }}
            value={firmDetails?.district_id || ''}
            sx={{
              color: 'white',
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '.MuiSvgIcon-root': {
                color: 'white',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  bgcolor: 'white',
                  '& .MuiMenuItem-root': {
                    padding: '10px',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  },
                },
              },
            }}
          >
            {districts.map((district) => (
              <MenuItem value={district.value}>{district.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.address_line_1}
        >
          <TextField
            className='darkBackground'
            fullWidth
            id='Address'
            type='text'
            value={firmDetails?.address_line_1}
            color='secondary'
            onChange={(e) =>
              setFirmDetails({
                ...firmDetails,
                address_line_1: e.target.value,
              })
            }
            label='Address Line 1'
          />
          {errors.address_line_1 && (
            <FormHelperText>{errors.address_line_1}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.address_line_2}
        >
          <TextField
            className='darkBackground'
            fullWidth
            id='Address'
            type='text'
            value={firmDetails.address_line_2}
            color='secondary'
            onChange={(e) =>
              setFirmDetails({
                ...firmDetails,
                address_line_2: e.target.value,
              })
            }
            label='Address Line 2'
          />
          {errors.address_line_2 && (
            <FormHelperText>{errors.address_line_2}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.address_line_3}
        >
          <TextField
            className='darkBackground'
            fullWidth
            id='Address'
            type='text'
            value={firmDetails.address_line_3}
            color='secondary'
            onChange={(e) =>
              setFirmDetails({
                ...firmDetails,
                address_line_3: e.target.value,
              })
            }
            label='Address Line 3'
          />
          {errors.address_line_3 && (
            <FormHelperText>{errors.address_line_3}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          sx={{ width: '38%', marginRight: '2%' }}
          margin='normal'
          error={!!errors.city}
        >
          <InputLabel
            sx={{
              color: 'white',
              '&.Mui-focused': {
                color: 'white',
              },
            }}
            id='city'
          >
            City
          </InputLabel>
          <Select
            label='City'
            onChange={(e) => {
              const selectedValue = e.target.value;
              const selectedLabel = allCities.find(
                (option) => option.value === selectedValue,
              ).label;
              setFirmDetails({
                ...firmDetails,
                location_id: selectedValue,
                location_name: selectedLabel,
                ...(firstSelection === 'city' ? { firm_pincode: '' } : {}),
              });
            }}
            value={firmDetails?.location_id || ''}
            sx={{
              color: 'white',
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '.MuiSvgIcon-root': {
                color: 'white',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  bgcolor: 'white',
                  '& .MuiMenuItem-root': {
                    padding: '10px',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  },
                },
              },
            }}
          >
            {allCities.map((city) => (
              <MenuItem value={city.value}>{city.label}</MenuItem>
            ))}
          </Select>
          {errors.city && <FormHelperText>{errors.city}</FormHelperText>}
        </FormControl>
        <FormControl
          sx={{ width: '40%' }}
          margin='normal'
          error={!!errors.firm_pincode}
        >
          <InputLabel
            sx={{
              color: 'white',
              '&.Mui-focused': {
                color: 'white',
              },
            }}
            id='pincode'
          >
            Pincode
          </InputLabel>
          <Select
            label='Pincode'
            value={firmDetails?.firm_pincode || ''}
            onChange={(e) => {
              const selectedValue = e.target.value;
              setFirmDetails({
                ...firmDetails,
                firm_pincode: selectedValue,
                ...(firstSelection === 'pincode'
                  ? { location_id: '', location_name: '' }
                  : {}),
              });
            }}
            sx={{
              color: 'white',
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
              '.MuiSvgIcon-root': {
                color: 'white',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  bgcolor: 'white',
                  '& .MuiMenuItem-root': {
                    padding: '10px',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  },
                },
              },
            }}
          >
            {allPincodes.map((pincode) => (
              <MenuItem value={pincode.value}>{pincode.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box sx={{ my: 2, width: '80%' }}>
          <Button
            onClick={handleSubmit}
            variant='contained'
            color='primary'
            fullWidth
          >
            Continue
          </Button>
        </Box>
      </Box>
    </OnboardingContainer>
  );
};

export default FirmOnboarding;
